<template>
  <div id="vice-president-award-preview" class="professional-preview-dialog">
    <v-card class="main-preview-container" elevation="8">
      <!-- Professional App Bar -->
      <div class="professional-app-bar">
        <div class="app-bar-background">
          <div class="background-pattern"></div>
          <div class="background-overlay"></div>
        </div>

        <div class="app-bar-content">
          <div class="left-section">
            <div class="app-bar-icon-wrapper">
              <v-icon size="32" color="white" class="app-bar-icon"
                >mdi-trophy-award</v-icon
              >
            </div>
            <div class="title-content">
              <h1 class="app-bar-title">{{ PageTitle }}</h1>
              <div v-if="PageDescription" class="app-bar-subtitle">
                {{ PageDescription }}
              </div>
            </div>
          </div>

          <div class="right-section">
            <div class="action-buttons-wrapper">
              <v-btn @click="closePrompt" class="close-button" outlined>
                <v-icon left size="18">mdi-close</v-icon>
                Close
              </v-btn>
            </div>
          </div>
        </div>
      </div>

      <!-- Loading -->
      <div class="professional-loading-section" v-if="LoadingFlag">
        <div class="loading-container">
          <v-progress-circular
            indeterminate
            size="64"
            width="4"
            color="#1976d2"
          ></v-progress-circular>
          <p class="loading-text mt-4">Loading award details...</p>
        </div>
      </div>

      <!-- Main Content -->
      <v-card-text
        class="main-content-wrapper"
        v-if="row != '' && !LoadingFlag"
      >
        <v-container class="py-0">
          <!-- Award Details -->
          <div class="award-section-card mb-4">
            <div class="section-header">
              <div class="section-title-wrapper">
                <v-icon size="24" color="#1976d2" class="mr-2"
                  >mdi-certificate</v-icon
                >
                <h3 class="section-title">Award Details</h3>
              </div>
            </div>

            <div class="section-content">
              <v-row>
                <v-col cols="12" sm="6" lg="3">
                  <div class="detail-item">
                    <h6 class="detail-label">Award Status</h6>
                    <div class="status-chip-wrapper">
                      <v-chip
                        :color="row.AwardStatusColor"
                        class="status-chip elevation-2"
                        label
                      >
                        <v-icon left size="16">mdi-flag</v-icon>
                        {{ row.AwardStatusTxt }}
                      </v-chip>
                    </div>
                  </div>
                </v-col>

                <v-col cols="12" sm="6" lg="3">
                  <div class="detail-item">
                    <h6 class="detail-label">Register Number</h6>
                    <p class="detail-value">{{ row.AwardRegisterNumber }}</p>
                  </div>
                </v-col>

                <v-col cols="12" sm="6" lg="3">
                  <div class="detail-item">
                    <h6 class="detail-label">Award Type</h6>
                    <p class="detail-value">{{ row.AwardTypeTitleTxt }}</p>
                  </div>
                </v-col>

                <v-col cols="12" sm="6" lg="3">
                  <div class="detail-item">
                    <h6 class="detail-label">Award Category</h6>
                    <p class="detail-value">{{ row.AwardCategoryName }}</p>
                  </div>
                </v-col>
              </v-row>
            </div>
          </div>

          <!-- Nominee Details -->
          <div class="award-section-card mb-4">
            <div class="section-header">
              <div class="section-title-wrapper">
                <v-icon size="24" color="#1976d2" class="mr-2"
                  >mdi-account-circle</v-icon
                >
                <h3 class="section-title">Nominee Details</h3>
              </div>
            </div>

            <div class="section-content">
              <div class="member-photo-section" v-if="row.MemberImage != ''">
                <div class="photo-container">
                  <v-avatar size="120" class="member-avatar elevation-4">
                    <v-img
                      :src="row.MemberImage"
                      :alt="row.MemberFullName"
                      cover
                    ></v-img>
                  </v-avatar>
                  <div class="photo-overlay">
                    <v-icon color="white" size="20">mdi-camera</v-icon>
                  </div>
                </div>
              </div>

              <v-row class="mt-4">
                <v-col cols="12" sm="6" lg="3">
                  <div class="detail-item">
                    <h6 class="detail-label">
                      <v-icon size="16" class="mr-1">mdi-account</v-icon> Full
                      Name
                    </h6>
                    <p class="detail-value">{{ row.MemberFullName }}</p>
                  </div>
                </v-col>

                <v-col cols="12" sm="6" lg="3">
                  <div class="detail-item">
                    <h6 class="detail-label">
                      <v-icon size="16" class="mr-1">mdi-account-box</v-icon>
                      Membership ID
                    </h6>
                    <p class="detail-value">{{ row.MembershipId }}</p>
                  </div>
                </v-col>

                <v-col cols="12" sm="6" lg="3">
                  <div class="detail-item">
                    <h6 class="detail-label">
                      <v-icon size="16" class="mr-1">mdi-email</v-icon> Email
                      Address
                    </h6>
                    <p class="detail-value">{{ row.EmailId }}</p>
                  </div>
                </v-col>

                <v-col cols="12" sm="6" lg="3">
                  <div class="detail-item">
                    <h6 class="detail-label">
                      <v-icon size="16" class="mr-1">mdi-phone</v-icon> Mobile
                      Number
                    </h6>
                    <p class="detail-value">{{ row.MobileNo }}</p>
                  </div>
                </v-col>
              </v-row>
            </div>
          </div>

          <!-- Judging Criteria Details -->
          <div class="award-section-card mb-4">
            <div class="section-header">
              <div class="section-title-wrapper">
                <v-icon size="24" color="#1976d2" class="mr-2"
                  >mdi-clipboard-list</v-icon
                >
                <h3 class="section-title">Judging Criteria Details</h3>
              </div>
            </div>

            <div class="section-content">
              <div
                v-for="(item, index) in row.AwardAnswersArray"
                :key="index"
                class="criteria-item-wrapper"
              >
                <div
                  class="criteria-title-section"
                  v-if="item.CriteriaTitleFlag"
                >
                  <div class="criteria-title-card">
                    <div class="criteria-title-content">
                      <h4 class="criteria-main-title">
                        <v-icon size="20" color="#4caf50" class="mr-2"
                          >mdi-bookmark</v-icon
                        >
                        {{ item.CriteriaTitle }}
                      </h4>
                      <div class="criteria-score-badge">
                        <v-chip
                          color="#4caf50"
                          text-color="white"
                          small
                          class="score-chip"
                        >
                          <v-icon left size="14">mdi-star</v-icon>
                          Score: {{ item.CriteriaScore }}
                        </v-chip>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="question-answer-section">
                  <div class="question-card">
                    <div class="question-header">
                      <v-icon size="18" color="#ff9800" class="mr-2"
                        >mdi-help-circle</v-icon
                      >
                      <h6 class="question-label">Question</h6>
                    </div>
                    <p class="question-text">{{ item.QuestionsText }}</p>
                  </div>

                  <div class="answer-card mt-3">
                    <div class="answer-header">
                      <v-icon size="18" color="#2196f3" class="mr-2"
                        >mdi-message-reply</v-icon
                      >
                      <h6 class="answer-label">Answer</h6>
                    </div>
                    <div class="answer-content">
                      <p class="answer-text">{{ item.AnswerText }}</p>
                    </div>
                  </div>
                </div>

                <v-divider
                  class="criteria-divider"
                  v-if="index < row.AwardAnswersArray.length - 1"
                ></v-divider>
              </div>
            </div>
          </div>

          <!-- Attachments -->
          <template
            v-if="
              row.AnswerAttachmentOfficers &&
              row.AnswerAttachmentOfficers.length > 0
            "
          >
            <div class="award-section-card mb-4">
              <div class="section-header">
                <div class="section-title-wrapper">
                  <v-icon size="24" color="#9c27b0" class="mr-2"
                    >mdi-image-multiple</v-icon
                  >
                  <h3 class="section-title">Award Attachments</h3>
                </div>
              </div>

              <div class="section-content">
                <v-row wrap class="mt-2">
                  <v-col
                    cols="12"
                    sm="6"
                    md="4"
                    lg="3"
                    v-for="(data, k) in row.AnswerAttachmentOfficers"
                    :key="k"
                  >
                    <v-card class="attachment-preview-card" elevation="3">
                      <div class="attachment-preview-header">
                        <v-icon color="white" size="18">mdi-image</v-icon>
                        <span class="attachment-preview-title"
                          >Image {{ k + 1 }}</span
                        >
                      </div>

                      <v-card-text class="attachment-preview-content">
                        <div
                          v-if="
                            data.EventImagesArray &&
                            data.EventImagesArray.length > 0
                          "
                          class="attachment-images"
                        >
                          <viewer rebuild :images="data.EventImagesArray">
                            <div class="images-grid">
                              <div
                                v-for="(src, idx) in data.EventImagesArray"
                                :key="idx"
                                class="image-preview-item"
                              >
                                <img
                                  :src="src"
                                  :alt="`Attachment image ${idx + 1}`"
                                  class="preview-img"
                                />
                                <div class="image-overlay-preview">
                                  <v-icon color="white" size="16"
                                    >mdi-magnify-plus</v-icon
                                  >
                                </div>
                              </div>
                            </div>
                          </viewer>
                        </div>

                        <div class="attachment-details-info">
                          <div class="detail-row-preview">
                            <v-icon size="16" color="#9c27b0" class="mr-2"
                              >mdi-calendar</v-icon
                            >
                            <span class="detail-label-preview">Date:</span>
                            <span class="detail-value-preview">{{
                              data.EventDate
                            }}</span>
                          </div>
                          <div class="detail-row-preview mt-2">
                            <v-icon size="16" color="#9c27b0" class="mr-2"
                              >mdi-tag</v-icon
                            >
                            <span class="detail-label-preview">Name:</span>
                            <span class="detail-value-preview">{{
                              data.EventName
                            }}</span>
                          </div>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </div>
            </div>
          </template>

          <!-- Video -->
          <div v-if="row.AwardVideoPath != null" class="award-section-card">
            <div class="section-header">
              <div class="section-title-wrapper">
                <v-icon size="24" color="primary" class="mr-2"
                  >mdi-video</v-icon
                >
                <h3 class="section-title-primary">Video Submission</h3>
              </div>
            </div>
            <div class="section-content">
              <div class="video-submission-wrapper">
                <div class="video-info-alert">
                  <v-icon color="#d32f2f" class="mr-2"
                    >mdi-information-outline</v-icon
                  >
                  <div>
                    <strong class="video-alert-title">Video Format:</strong>
                    <p class="video-alert-text">
                      MP4, AVI, or MOV format • Maximum 25MB
                    </p>
                  </div>
                </div>

                <div class="video-player-container">
                  <video
                    :src="row.AwardVideoPath"
                    width="100%"
                    controls
                    class="video-player"
                  ></video>
                </div>
              </div>
            </div>
          </div>
        </v-container>
      </v-card-text>

      <v-card-actions class="professional-footer-actions">
        <div class="footer-content-centered">
          <v-btn
            @click="closePrompt"
            class="professional-close-btn"
            large
            elevation="3"
            color="#1976d2"
          >
            <v-icon left size="20">mdi-close-circle</v-icon>
            Close Preview
          </v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import Swal from "sweetalert2";

export default {
  mixins: [common],
  components: {},
  props: {
    previewRecordPrompt: {
      required: true,
      Type: Boolean,
    },
    recordData: {
      required: true,
    },
  },
  data() {
    return {
      valid1: true,
      search: "",
      StartupLoadingFlag: false,
      LoadingFlag: false,
      SubmitFlag: false,

      ProgessStart: 0,
      uploadPercentage: 0,

      tab: "",

      row: [],

      addRecordPrompt: false,
      editRecordPrompt: false,

      ActiveStatus: "",

      valid: true,

      RoleId: "",
      PageInfo: {},
      PageTitle: "",
      PageDescription: "",
      CurrentYearId: 0,
      YearName: "",
      NextYearCode: "",
      NextYearName: "",
    };
  },
  computed: {},
  watch: {
    PageInfo: function () {
      console.log("watch PageInfo");
      this.LoadingFlag = false;
      var tr = this.PageInfo;
      console.log({ tr });
      var n1 = Object.keys(tr).length;
      console.log({ n1 });
      if (n1 > 0) {
        var flag = tr.PagePermissionFlag;
        console.log("PagePermissionFlag=" + flag);

        if (!flag) {
          this.$router.push("/access-denied");
        }

        var zone_name = this.$session.get("ZoneName");
        zone_name = zone_name == (null || undefined) ? 0 : zone_name;

        this.PageTitle = tr.PageTitle + " - " + zone_name;
        this.PageDescription = tr.PageDescription;
        this.FloatingButtonOptions = tr.FloatingButtonOptions;

        var CurrentJciYearId = parseInt(tr.CurrentJciYearId);
        console.log({ CurrentJciYearId });

        var YearName = parseInt(tr.CurrentJciYearName);
        console.log({ YearName });
        this.YearName = YearName;

        this.CurrentYearId = CurrentJciYearId;

        this.pageData();
      }
    },
  },
  created() {
    // this.initialize()
  },
  methods: {
    refreshPageData() {
      console.log("refreshPageData called");
      this.LoadingFlag = true;
      var url1 = "api/menu-details/show";
      var condition1 = {
        UserInterface: 1,
        Module: "national_vice_president_award",
        Action: "preview",
      };
      this.getPageDetails("PageInfo", {}, url1, condition1);
    },
    pageData() {
      console.log("pageData called");

      var recordData = this.recordData;
      console.log({ recordData });
      this.getTableRecords();
    },
    closePrompt() {
      console.log("closePrompt called");
      this.$emit("hidePreviewRecordPrompt");
    },
    getTableRecords() {
      console.log("getTableRecords called");

      var AwardId = this.recordData.AwardId;
      console.log({ AwardId });

      if (AwardId > 0) {
        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/award/show";
        var upload = {
          UserInterface: 1,
          Award: AwardId,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        this.RecordFlag = false;

        const thisIns = this;
        var output = "";
        var records = "";
        var successTxt = "";
        var errorTxt = "";
        var flag = 0;

        this.LoadingFlag = true;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            thisIns.LoadingFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            output = response.data.output;
            records = response.data.records;
            console.log("output=" + output + ", flag=" + flag);
            successTxt = response.data.success;
            errorTxt = response.data.error;
            console.log("successTxt=" + successTxt + ", errorTxt=" + errorTxt);

            thisIns.RecordFlag = flag;

            if (flag == 1) {
              console.log("records=" + JSON.stringify(records));

              thisIns.row = records;
              thisIns.toast("success", output);
            } else {
              thisIns.toast("error", output);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.toast("error", error);
            thisIns.LoadingFlag = false;
          });
      } else {
        var message = "Award details not found.";
        console.log("error=" + message);
      }
    },
  },
  beforeMount() {
    console.log("beforeMount called");

    // var RoleId = this.$session.get("RoleId");
    // RoleId = RoleId == (null || undefined) ? "" : RoleId;
    // console.log({ RoleId });
    // this.RoleId = RoleId;

    this.refreshPageData();
  },
};
</script>

<style scoped lang="scss">
.professional-preview-dialog {
  background: linear-gradient(135deg, #f5f7fa 0%, #e8eaf6 100%);
  min-height: 100vh;
}

.main-preview-container {
  position: relative;
  overflow: hidden;
  border-radius: 16px !important;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15) !important;
}

/* Professional App Bar Styles */
.professional-app-bar {
  position: relative;
  width: 100%;
  overflow: hidden;
  padding: 24px 32px;
  background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);

  .app-bar-background {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    overflow: hidden;

    .background-pattern {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-image: repeating-linear-gradient(
          45deg,
          rgba(255, 255, 255, 0.03) 0px,
          rgba(255, 255, 255, 0.03) 2px,
          transparent 2px,
          transparent 4px
        ),
        repeating-linear-gradient(
          -45deg,
          rgba(255, 255, 255, 0.03) 0px,
          rgba(255, 255, 255, 0.03) 2px,
          transparent 2px,
          transparent 4px
        );
      animation: patternFloat 20s linear infinite;
    }

    .background-overlay {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: linear-gradient(
        135deg,
        rgba(255, 255, 255, 0.1) 0%,
        transparent 100%
      );
    }
  }

  .app-bar-content {
    position: relative;
    z-index: 1;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .left-section {
      display: flex;
      align-items: center;
      gap: 16px;

      .app-bar-icon-wrapper {
        width: 56px;
        height: 56px;
        background: rgba(255, 255, 255, 0.15);
        border-radius: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        backdrop-filter: blur(10px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        animation: pulse 2s ease-in-out infinite;

        .app-bar-icon {
          animation: rotate 3s linear infinite;
        }
      }

      .title-content {
        .app-bar-title {
          font-size: 24px;
          font-weight: 700;
          color: white;
          margin: 0;
          text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
          letter-spacing: 0.5px;
        }

        .app-bar-subtitle {
          font-size: 13px;
          color: rgba(255, 255, 255, 0.9);
          margin-top: 2px;
          font-weight: 500;
        }
      }
    }

    .right-section {
      .action-buttons-wrapper {
        display: flex;
        gap: 12px;

        .close-button {
          background: rgba(255, 255, 255, 0.15) !important;
          color: white !important;
          border: 2px solid rgba(255, 255, 255, 0.3) !important;
          border-radius: 8px;
          font-weight: 600;
          text-transform: none;
          padding: 0 20px !important;
          backdrop-filter: blur(10px);
          transition: all 0.3s ease;

          &:hover {
            background: rgba(255, 255, 255, 0.25) !important;
            border-color: rgba(255, 255, 255, 0.5) !important;
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
          }
        }
      }
    }
  }
}

/* Loading Section */
.professional-loading-section {
  padding: 80px 20px;
  background: linear-gradient(135deg, #f5f7fa 0%, #e3f2fd 100%);

  .loading-container {
    text-align: center;

    .loading-text {
      font-size: 16px;
      color: #1976d2;
      font-weight: 500;
    }
  }
}

/* Main Content Wrapper */
.main-content-wrapper {
  padding: 32px 24px !important;
  background: linear-gradient(135deg, #fafafa 0%, #f5f5f5 100%);
}

/* Award Section Card */
.award-section-card {
  background: white;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
    transform: translateY(-2px);
  }

  .section-header {
    background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);
    padding: 20px 24px;
    position: relative;
    overflow: hidden;

    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: repeating-linear-gradient(
        45deg,
        rgba(255, 255, 255, 0.05) 0px,
        rgba(255, 255, 255, 0.05) 2px,
        transparent 2px,
        transparent 4px
      );
      animation: patternFloat 20s linear infinite;
    }

    .section-title-wrapper {
      display: flex;
      align-items: center;
      position: relative;
      z-index: 1;

      .section-title {
        font-size: 20px;
        font-weight: 700;
        color: white;
        margin: 0;
        text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
      }

      .section-title-primary {
        font-size: 20px;
        font-weight: 700;
        color: white;
        margin: 0;
        text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
      }
    }
  }

  .section-content {
    padding: 28px 24px;
  }
}

/* Detail Item Styles */
.detail-item {
  .detail-label {
    font-size: 13px;
    font-weight: 600;
    color: #666;
    margin-bottom: 8px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    display: flex;
    align-items: center;
  }

  .detail-value {
    font-size: 15px;
    font-weight: 500;
    color: #212121;
    margin: 0;
    padding: 12px 16px;
    background: linear-gradient(135deg, #f5f5f5 0%, #eeeeee 100%);
    border-radius: 8px;
    border-left: 4px solid #1976d2;
  }

  .status-chip-wrapper {
    display: inline-block;

    .status-chip {
      font-weight: 600 !important;
      font-size: 14px !important;
      padding: 16px 20px !important;
      height: auto !important;
      border-radius: 8px !important;
      transition: all 0.3s ease;

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
      }
    }
  }
}

/* Member Photo Section */
.member-photo-section {
  text-align: center;
  padding: 20px 0;

  .photo-container {
    position: relative;
    display: inline-block;

    .member-avatar {
      border: 4px solid #1976d2;
      box-shadow: 0 6px 20px rgba(25, 118, 210, 0.3);
      transition: all 0.3s ease;

      &:hover {
        transform: scale(1.05);
        box-shadow: 0 8px 30px rgba(25, 118, 210, 0.4);
      }
    }

    .photo-overlay {
      position: absolute;
      bottom: 8px;
      right: 8px;
      width: 32px;
      height: 32px;
      background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
    }
  }
}

/* Criteria Item Styles */
.criteria-item-wrapper {
  margin-bottom: 24px;

  &:last-child {
    margin-bottom: 0;
  }
}

.criteria-title-section {
  margin-bottom: 20px;

  .criteria-title-card {
    background: linear-gradient(135deg, #4caf50 0%, #388e3c 100%);
    border-radius: 12px;
    padding: 20px 24px;
    box-shadow: 0 4px 16px rgba(76, 175, 80, 0.2);

    .criteria-title-content {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;
      gap: 12px;

      .criteria-main-title {
        font-size: 18px;
        font-weight: 700;
        color: white;
        margin: 0;
        display: flex;
        align-items: center;
        text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
      }

      .criteria-score-badge {
        .score-chip {
          font-weight: 600 !important;
          padding: 12px 16px !important;
          height: auto !important;
          border-radius: 20px !important;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
        }
      }
    }
  }
}

.question-answer-section {
  .question-card,
  .answer-card {
    background: white;
    border-radius: 12px;
    padding: 20px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
    transition: all 0.3s ease;

    &:hover {
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
      transform: translateX(4px);
    }
  }

  .question-card {
    border-left: 4px solid #ff9800;

    .question-header {
      display: flex;
      align-items: center;
      margin-bottom: 12px;

      .question-label {
        font-size: 13px;
        font-weight: 700;
        color: #ff9800;
        margin: 0;
        text-transform: uppercase;
        letter-spacing: 0.5px;
      }
    }

    .question-text {
      font-size: 15px;
      color: #424242;
      line-height: 1.6;
      margin: 0;
      font-weight: 500;
    }
  }

  .answer-card {
    border-left: 4px solid #2196f3;

    .answer-header {
      display: flex;
      align-items: center;
      margin-bottom: 12px;

      .answer-label {
        font-size: 13px;
        font-weight: 700;
        color: #2196f3;
        margin: 0;
        text-transform: uppercase;
        letter-spacing: 0.5px;
      }
    }

    .answer-content {
      .answer-text {
        font-size: 15px;
        color: #212121;
        line-height: 1.8;
        margin: 0;
        background: linear-gradient(135deg, #e3f2fd 0%, #f5f5f5 100%);
        padding: 16px;
        border-radius: 8px;
      }
    }
  }
}

.criteria-divider {
  margin: 28px 0;
  border-color: rgba(0, 0, 0, 0.08);
}

/* Attachment Styles */
.attachment-preview-card {
  border-radius: 12px !important;
  overflow: hidden;
  transition: all 0.3s ease;
  border: 2px solid transparent;

  &:hover {
    border-color: #9c27b0;
    box-shadow: 0 8px 24px rgba(156, 39, 176, 0.2) !important;
    transform: translateY(-4px);
  }

  .attachment-preview-header {
    background: linear-gradient(135deg, #9c27b0 0%, #7b1fa2 100%);
    padding: 12px 16px;
    display: flex;
    align-items: center;
    gap: 8px;

    .attachment-preview-title {
      font-size: 14px;
      font-weight: 600;
      color: white;
      text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
    }
  }

  .attachment-preview-content {
    padding: 16px !important;

    .attachment-images {
      margin-bottom: 16px;

      .images-grid {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));
        gap: 8px;

        .image-preview-item {
          position: relative;
          aspect-ratio: 1;
          overflow: hidden;
          border-radius: 8px;
          cursor: pointer;

          .preview-img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            transition: transform 0.3s ease;
          }

          .image-overlay-preview {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(156, 39, 176, 0.8);
            display: flex;
            align-items: center;
            justify-content: center;
            opacity: 0;
            transition: opacity 0.3s ease;
          }

          &:hover {
            .preview-img {
              transform: scale(1.1);
            }

            .image-overlay-preview {
              opacity: 1;
            }
          }
        }
      }
    }

    .attachment-details-info {
      .detail-row-preview {
        display: flex;
        align-items: center;
        font-size: 13px;

        .detail-label-preview {
          font-weight: 600;
          color: #666;
          margin-right: 8px;
        }

        .detail-value-preview {
          color: #212121;
          font-weight: 500;
        }
      }
    }
  }
}

/* Video Submission Styles */
.video-submission-wrapper {
  .video-info-alert {
    background: linear-gradient(135deg, #ffebee 0%, #fce4ec 100%);
    border-left: 4px solid #d32f2f;
    padding: 16px 20px;
    border-radius: 8px;
    margin-bottom: 24px;
    display: flex;
    align-items: flex-start;
    gap: 12px;

    .video-alert-title {
      font-size: 14px;
      color: #d32f2f;
      font-weight: 700;
      display: block;
      margin-bottom: 4px;
    }

    .video-alert-text {
      font-size: 13px;
      color: #666;
      margin: 0;
      line-height: 1.5;
    }
  }

  .video-player-container {
    background: #000;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);

    .video-player {
      display: block;
      width: 100%;
      max-height: 500px;
      outline: none;
    }
  }
}

/* Professional Footer Actions */
.professional-footer-actions {
  padding: 24px 32px !important;
  background: linear-gradient(135deg, #f5f5f5 0%, #eeeeee 100%);
  border-top: 1px solid rgba(0, 0, 0, 0.08);

  .footer-content-centered {
    width: 100%;
    display: flex;
    justify-content: center;

    .professional-close-btn {
      border-radius: 12px !important;
      font-weight: 600 !important;
      text-transform: none !important;
      padding: 0 40px !important;
      height: 48px !important;
      font-size: 15px !important;
      color: white !important;
      box-shadow: 0 4px 16px rgba(25, 118, 210, 0.3) !important;
      transition: all 0.3s ease;

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 24px rgba(25, 118, 210, 0.4) !important;
      }
    }
  }
}

/* Animations */
@keyframes pulse {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes patternFloat {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(50px, 50px);
  }
}

/* Responsive Design */
@media (max-width: 768px) {
  .professional-app-bar {
    padding: 20px 16px;

    .app-bar-content {
      flex-direction: column;
      gap: 16px;

      .left-section {
        width: 100%;

        .app-bar-icon-wrapper {
          width: 48px;
          height: 48px;
        }

        .title-content {
          .app-bar-title {
            font-size: 20px;
          }

          .app-bar-subtitle {
            font-size: 12px;
          }
        }
      }

      .right-section {
        width: 100%;

        .action-buttons-wrapper {
          width: 100%;
          justify-content: stretch;

          .close-button {
            flex: 1;
          }
        }
      }
    }
  }

  .main-content-wrapper {
    padding: 20px 12px !important;
  }

  .award-section-card {
    .section-header {
      padding: 16px 16px;

      .section-title-wrapper {
        .section-title,
        .section-title-primary {
          font-size: 18px;
        }
      }
    }

    .section-content {
      padding: 20px 16px;
    }
  }

  .criteria-title-section {
    .criteria-title-card {
      padding: 16px 16px;

      .criteria-title-content {
        .criteria-main-title {
          font-size: 16px;
        }
      }
    }
  }

  .professional-footer-actions {
    padding: 16px 16px !important;

    .footer-content-centered {
      .professional-close-btn {
        width: 100%;
        padding: 0 24px !important;
        height: 44px !important;
      }
    }
  }
}

@media (max-width: 600px) {
  .attachment-preview-content {
    .attachment-images {
      .images-grid {
        grid-template-columns: repeat(auto-fill, minmax(60px, 1fr));
        gap: 6px;
      }
    }
  }
}
</style>

